
// mentions
export const GET_MENTIONS = "/mentions";
export const ADD_NEW_MENTION = "/mentions";
export const UPDATE_MENTION = "/mentions";
export const DELETE_MENTION = "/mentions";


